function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_10643_146791)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 16H5.21875L6.40312 7.86562L5.21875 0H0V16Z",
  fill: "#6DA544"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 0H5.21875V16H16V0Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.21875 10.7812C6.75479 10.7812 8 9.53604 8 8C8 6.46396 6.75479 5.21875 5.21875 5.21875C3.68271 5.21875 2.4375 6.46396 2.4375 8C2.4375 9.53604 3.68271 10.7812 5.21875 10.7812Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.65308 6.60957V8.34395C3.65308 8.75876 3.81786 9.15659 4.11118 9.4499C4.4045 9.74322 4.80232 9.90801 5.21714 9.90801C5.63195 9.90801 6.02978 9.74322 6.3231 9.4499C6.61642 9.15659 6.7812 8.75876 6.7812 8.34395V6.60645H3.6562L3.65308 6.60957Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.21877 8.86875C4.93127 8.86875 4.6969 8.63438 4.6969 8.34688V7.65625H5.74065V8.34375C5.74065 8.63125 5.50627 8.86563 5.21877 8.86563V8.86875Z",
  fill: "#EEEEEE"
}));

function SvgPt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10643_146791",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.9783fa57.svg";
export { ForwardRef as ReactComponent };